import privacyConsentStyle from '../../assets-soapy/jss/soapy/components/privacyConsentStyle.jsx'
import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { withTranslation } from 'react-i18next'

const PrivacyPolicyConsent = ({ classes, handleMoreInfo, handleApproval, t }) => {
  return (
    <div
      id='consent'
      className={classes.consent}
    >

      <div id='consentContainer'>
       Please read and accept the
        <a id='consentContainerLink' href='# ' onClick={handleMoreInfo} className={classes.consent_a} target='_blank'>{t('Privacy Policy')}</a>.
       By Clicking "I agree" you confirm that you have read and agreed to our Privacy Policy"
      </div>
      <a id='consentContainerApprovalLink' href='# ' className={classes.consent_a_consentOK} onClick={handleApproval}>{t('I agree')}</a>
    </div>
  )
}

export default withStyles(privacyConsentStyle)(withTranslation()(PrivacyPolicyConsent))
